export const SITE_NAME = 'Drs.Farm';
export const SITE_URL = String(import.meta.env.VITE_SITE_URL || 'https://drs-farm.web.app').replace(/\/+$/, '');
export const DEFAULT_DESCRIPTION = '食が健康をつくる。糖尿病専門医の視点と、農薬に頼らない農家の実践をつなぎ、未病予防と地域の健康づくりを進めるDrs.Farm。';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/favicon.png`;

export function toAbsoluteUrl(path = '/') {
  if (!path) return SITE_URL;
  if (/^https?:\/\//.test(path)) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

export function buildPageTitle(title) {
  return title ? `${title} | ${SITE_NAME}` : SITE_NAME;
}

export function stripHtml(value) {
  return String(value || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function truncateText(value, maxLength = 140) {
  const text = stripHtml(value);
  if (text.length <= maxLength) return text;
  return `${text.slice(0, Math.max(0, maxLength - 1)).trimEnd()}…`;
}
